import { DropDown } from 'src/app/shared/model/base-model';
import { OnInit, Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ScAddressService } from 'src/app/core/services/sc/sc-address.service';
import { ScCountryService } from 'src/app/core/services/sc/sc-country.service';



@Component({
    selector: 'sf-sc-country-dropdown',
    templateUrl: './sc-country-dropdown.component.html',
    styleUrls: ['./sc-country-dropdown.component.scss']
})

export class ScCountryDropdownComponent implements OnInit, OnChanges{

    public list : DropDown[];
    @Input() placeHolderLanguage: string;
    public selectedItem: DropDown;

    @Input() id: string;
    @Input() languageCode: string = "pt-BR";
    @Input() disabled: boolean = false;
    @Output() chosedItem = new EventEmitter();

    constructor(  private countryService: ScCountryService){ }

    ngOnInit(): void {
        this.getList();
    }

    ngOnChanges(): void {
        this.getList();
    }

    getList() {
        this.countryService.getDropDownList().subscribe(
          {
            next: (res) => {
                if (res)
                    this.list = res.data;
                    if (this.list !== null){
                        this.selectedItem = this.list.find(x => x.id == this.id);
                        if (this.selectedItem == null || this.selectedItem.id == undefined)
                        {
                            this.selectedItem = this.list[0];
                            this.feedback();
                        }


                    }

            },
            error: (err) => {
                console.log(`CountryDropDown - getList : ${err}.`);
            }
        });
      }

    feedback(){
        this.chosedItem.emit(this.selectedItem)
    }

}
